export const EVENT_NAME = {
  CLICK: "Content Card Opened",
  IMPRESSION: "Content Card Impression",
  DISMISS: "Content Card Dismissed"
};
